import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';

import ParamSelectInput from './ParamSelectInput';
import DownloadButton from './DownloadButton';
import ParamDateInput from './ParamDateInput';
import ParamAutocompleteInput from './ParamAutocompleteInput';

const RulesReportCard = () => {
    const [prestacionId, setPrestacionId] = useState(undefined);
    const [tipoTransaccionId, setTipoTransaccionId] = useState(undefined);
    const [fechaPrestacion, setFechaPrestacion] = useState(undefined);

    const reporteUrl = () => (prestacionId && tipoTransaccionId) ? `reportes/reglas-aplicar?idPrestacion=${prestacionId}&idTipoTransaccion=${tipoTransaccionId}&fechaPrestacion=${fechaPrestacion}` : undefined;

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                    Reporte
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                    Reglas a usar según prestación, tipo de transacción y fecha de prestación
                </Typography>

                <ParamAutocompleteInput resource="prestaciones" onChange={setPrestacionId} />

                <ParamSelectInput resource="tipos-transaccion" onChange={setTipoTransaccionId} />
                <ParamDateInput label="resources.reportes.fields.fechaPrestacion" onChange={setFechaPrestacion} />
            </CardContent>
            <CardActions>
                <DownloadButton filename="Reporte de Reglas.pdf" url={reporteUrl()}/>
            </CardActions>
        </Card>
    );
}

export default RulesReportCard;